import { useState } from "react";

import { deleteManyProject, deleteProject } from "../../../api/projects";
import { restoreProjects } from "../../../api/trash";
import { handleSelectedProject } from "../../Dashboard/hooks/helpers";

export const useTrashProjects = (getTrash, projects, handleCloseDeleteAllModal, handleCloseRestoreAllModal) => {
  const [projectsPicked, setProjectsPicked] = useState([]);

  const handlePickedProject = (project) => {
    setProjectsPicked((prev) => handleSelectedProject(prev, project));
  };

  const handleDeleteProjects = async () => {
    if (projectsPicked.length) {
      await deleteManyProject(projectsPicked);
    }
  };

  const handleDeleteProject = async (selectedProject) => {
    const params = { id: selectedProject.id, teamId: selectedProject.teamId || "" };

    await deleteProject(params);
    getTrash();
  };

  const handleRestoreProjects = async () => {
    if (projectsPicked.length) {
      const projectIds = projectsPicked.map((projectPicked) => projectPicked.id);
      await restoreProjects({ projectIds, teamId: projectsPicked[0].teamId });
    }
  };

  const handleDeleteAllProjects = async () => {
    handleCloseDeleteAllModal();

    if (projects.length) {
      await deleteManyProject(projects);
    }

    getTrash();
  };

  const handleRestoreAllProjects = async () => {
    handleCloseRestoreAllModal();

    if (projects.length) {
      const projectIds = projects.map((project) => project.id);
      await restoreProjects({ projectIds });

      getTrash();
    }
  };

  const handleRestoreProject = async (selectedProject) => {
    const params = { projectIds: [selectedProject.id], teamId: selectedProject.teamId };

    await restoreProjects(params);
    getTrash();
  };

  return {
    projectsPicked,

    handlePickedProject,

    handleDeleteProject,
    handleDeleteProjects,
    handleDeleteAllProjects,

    handleRestoreProject,
    handleRestoreProjects,
    handleRestoreAllProjects,
  };
};
